<style lang="scss" scoped>
  @import "@/assets/scss/vuexy/pages/DevicesMenu.scss";
</style>
<template>
  <div class="grid grid-cols-1  sm:grid-cols-2 sm:grid-cols-3  gap-4 mt-8">
    <principalMenuItem v-for="item in items"
      :key="item.title"
      :title="$t(item.title)"
      :description="item.description"
      :route="item.route"
      :img="item.img"
    ></principalMenuItem>
  </div>
</template>
<script>
import principalMenuItem from '@/components/principalMenuItem/principalMenuItem.vue'

export default {
  components: {
    principalMenuItem
  },
  data () {
    return {
      items: [
        {
          route: '/airflow',
          img: 'polucion',
          title: 'Labels.AirFlow',
          description: 'MeteringIM'
        },
        {
          route: '/energy',
          img: 'energy',
          title: 'Energy',
          description: 'MeteringIM'
        },
        {
          route: '/doors',
          img: 'apertura',
          title: 'Labels.DoorsSensor',
          description: 'DoorS'
        },
        {
          route: '/env',
          img: 'temperature',
          title: 'Labels.EnvTemperature',
          description: 'WatherS'
        },
        {
          route: '/agro',
          img: 'agro',
          title: 'Labels.Agro',
          description: 'Agro'
        },
        {
          route: '/labels',
          img: 'etiquetas',
          title: 'Labels.SmartLabels',
          description: 'LabelsEP'
        }

      ]
    }
  }
}
</script>
